import { useCallback } from 'react';

import { useAppAlert } from '@Components/AppAlert';
import RouterProvider from '@Components/RouterProvider';
import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';
import FormWrapper from '@Components/form/Wrapper';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { DashboardProvider, useDashboardStore } from '../store';
import UserProfileLayout from '../views/user-profile/Layout';

function DashboardForm() {
  const { useSubmit, useLoad, item, list, loading } = useDashboardStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad()

  const handleSubmit = useSubmit()

  const handleSubmitAndRefresh = useCallback(async payload => {
    try {
      await handleSubmit(payload)

      handleSuccess('Success', 'Site edited.');

      try {
        await list()
      } catch {
        handleError('Error', 'Failed to fetch site.');
      }
    } catch {
      handleError('Error', 'Site was not saved.');
    }
  }, [handleSubmit, list, handleSuccess, handleError])

  if (!item) return null

  return <>
    <FormWrapper title='User Profile Driven Paths'>
      <Heading data={item} />
      <Form data={item} onSubmit={handleSubmitAndRefresh} loading={loading} />
    </FormWrapper>
  </>
}

export default function DashboardFormLayout() {
  return <RouterProvider>
    <DashboardProvider>
      <DashboardForm />
      <Router>
        <PrivateRoute path={["/path/dashboard/user_profile/add", "/path/dashboard/user_profile/:id"]} component={UserProfileLayout} />
      </Router>
    </DashboardProvider>
  </RouterProvider>
}

